import { _ } from "../../core/polyglot/polyglot.js";
import AbstractAgencyBillingStatus from "./AbstractAgencyBillingStatus.js";

let instance;

/**
 * An agency with this status isn't billed because it is in a
 * on-boarding temporary phase.
 */
export default class BoardingAgencyBillingStatus extends AbstractAgencyBillingStatus {
	label() {
		return _("Temporarily on-boarding");
	}

	static getType() {
		return "Boarding";
	}

	static instance() {
		instance ||= new this();

		return instance;
	}
}
